import React from 'react';
import classnames from 'classnames';

import Breadcrumb from 'app/Breadcrumb/container';
import PreviewPane from 'app/PreviewPane/container';

import styles from './Canvas.css';

/**
 * Returns canvas component
 * @returns {object} the component.
 */
const Canvas = () => (
  <div className={classnames('d-flex flex-column w-100', styles.wrapper)}>
    <Breadcrumb />
    <PreviewPane />
  </div>
);

export default Canvas;
